var map = {
	"./account.svg": 1128,
	"./account_badged.svg": 1131,
	"./account_checked.svg": 1132,
	"./alert-circle.svg": 1133,
	"./arrow-left_rounded.svg": 1134,
	"./arrow-left_squared.svg": 1135,
	"./arrow-right_rounded.svg": 1136,
	"./arrow-right_squared.svg": 1137,
	"./arrow-top.svg": 1138,
	"./bank-check.svg": 1139,
	"./bell-checkmark.svg": 1140,
	"./bell-plus.svg": 1141,
	"./bell.svg": 1142,
	"./bookmark.svg": 1143,
	"./bookmark_filled.svg": 1144,
	"./bullet-leaf.svg": 1145,
	"./calendar.svg": 1146,
	"./cart-checkmark.svg": 1147,
	"./cart-clock.svg": 1148,
	"./cart-plus.svg": 1149,
	"./cart.svg": 1150,
	"./cart_added.svg": 1151,
	"./cart_deleted.svg": 1152,
	"./cart_emptied.svg": 1153,
	"./chat.svg": 1154,
	"./checkmark-white.svg": 1155,
	"./checkmark.svg": 1156,
	"./chevron-down.svg": 1157,
	"./chevron-left.svg": 1158,
	"./chevron-right.svg": 1159,
	"./chevron-up.svg": 1160,
	"./clock.svg": 1161,
	"./close.svg": 1162,
	"./copy.svg": 1163,
	"./cost.svg": 1164,
	"./cream.svg": 1165,
	"./credit-card.svg": 1166,
	"./delete.svg": 1167,
	"./delivery.svg": 1168,
	"./download.svg": 1169,
	"./edit.svg": 1170,
	"./erase.svg": 1171,
	"./error-circle.svg": 1172,
	"./file-pdf.svg": 1173,
	"./filter.svg": 1174,
	"./gift.svg": 1175,
	"./heart.svg": 1176,
	"./heart_filled.svg": 1177,
	"./hide.svg": 1178,
	"./history.svg": 1179,
	"./hourglass.svg": 1180,
	"./info-circle.svg": 1181,
	"./invoice.svg": 1182,
	"./link.svg": 1183,
	"./lock.svg": 1184,
	"./log-in.svg": 1185,
	"./log-out.svg": 1186,
	"./menu.svg": 1187,
	"./microscope.svg": 1188,
	"./minus.svg": 1189,
	"./mortar.svg": 1190,
	"./offers.svg": 1191,
	"./package.svg": 1192,
	"./package_returned.svg": 1193,
	"./payment-4x.svg": 1194,
	"./payments.svg": 1195,
	"./place_added.svg": 1196,
	"./play-overlay.svg": 1197,
	"./play.svg": 1198,
	"./plus.svg": 1199,
	"./question-circle.svg": 1200,
	"./rebuy.svg": 1201,
	"./recipe-book.svg": 1202,
	"./search.svg": 1203,
	"./share.svg": 1204,
	"./shop.svg": 1205,
	"./show.svg": 1206,
	"./star.svg": 1207,
	"./star_filled.svg": 1208,
	"./survey-logo.svg": 1209,
	"./time.svg": 1210,
	"./transfer.svg": 1211,
	"./unsub.svg": 1212,
	"./warning.svg": 1213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1127;